import styled from 'styled-components'
import I from '@ied/icon'

export const Container = styled.div`
  font-family: Open sans, sans-serif;
  text-align: center;
  margin: 10px;
  padding: 10px;
  width: 160px;
  height: 160px;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  background-color: transparent;
  transition: background-color 0.3s;
  user-select: none;
  color: black;
  &:hover {
    background-color: #e2e1e1;
  }
  &:active {
    background-color: #f1f1f1;
  }
`

export const Title = styled.h3`
  font-size: 13px;
  margin: 5px 0 0;
  font-weight: bold;
  overflow: hidden;
  line-height: 15px;
  width: 100%;
  max-height: 30px;
`

export const Description = styled.p`
  overflow: hidden;
  font-size: 12px;
  color: #545151;
  font-weight: lighter;
  line-height: 15px;
  max-height: 45px;
  margin-bottom: 1px;
  margin-top: 8px;
  width: 100%;
`

export const Icon = styled(I)`
  display: block;
  font-size: 46px;
`

export const Box = styled.div`
  position: relative;
  margin-top: ${({ margin }) => (margin ? '30px' : '5px')};
`

export const Notifications = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  border-radius: 22px;
  height: 22px;
  width: 22px;
  background-color: #8bc34a;
  line-height: 22px;
  vertical-align: middle;
  text-align: center;
  font-size: 12px;
  color: white;
`



// WEBPACK FOOTER //
// ./src/Styled.js